import { create } from "zustand";
import { MainPageLayoutContainerProps } from "../components/MainPageLayoutContainer";
import { RouteNameType } from "../route-config";

type DelegateProps = MainPageLayoutContainerProps;

interface PageStoreState {
    name: RouteNameType | null;
    subMenu: DelegateProps["subMenu"];
    activeKeys: DelegateProps["activeKeys"];
    setName: (name: RouteNameType) => void;
    configure: (config?: DelegateProps) => void;
}

export const usePageStore = create<PageStoreState>(set => ({
    name: null,
    title: undefined,
    subMenu: undefined,
    activeKeys: undefined,
    setName: name => set({ name }),
    configure: config => set({ subMenu: config?.subMenu, activeKeys: config?.activeKeys }),
}));
